import { EmptyState } from "@bafe/ui";

import { LinkButton } from "../components/LinkButton";

export function NotFound() {
	return (
		<EmptyState
			title="We could not find that page"
			description="The link may be out of date, or the thing it pointed at may have been removed."
			action={
				<LinkButton to="/manage" variant="primary">
					Go to Overview
				</LinkButton>
			}
		/>
	);
}
